module.exports = __webpack_public_path__ + "static/media/iconCommand.9992db7b.svg";